import type { Theme } from '@mui/material/styles';
import type { SxProps } from '@mui/material';

export const columnActionsStyles: SxProps<Theme> = theme => ({
  width: theme.spacing(5),
  paddingLeft: 0,
  paddingRight: 0,
});
